module.exports = __webpack_public_path__ + "e81b9be2e169ee5a1c4e55d0e8df1038.woff2";


//////////////////
// WEBPACK FOOTER
// ./libs/font-awesome/webfonts/fa-regular-400.woff2
// module id = 349
// module chunks = 0